
/**
 * Row布局
 * wzhe
 */
var SgiUCVEO = function () {
    return ({
        cldSet: [],
        ap: "SD",
        auth: "王哲",
        cId: "SD_UI_UI_0001",
        crtTm: "2017-11-24 09:40:24",
        ctlH: "100%",
        ctlW: "100%",
        desId: "EP_EO_UI_0001",
        edAuth: "王哲",
        edTm: "2018-01-09 09:58:10",
        guid: "SD_UI_UI_0001new",
        mgn: "0 0 0 0",
        n: "UI管理页面new@",
        pad: "0 0 0 0",
        prmVsn: 176,
        sc: "0001new",
        ss: "UI",
        t: "fit",
        te: "SD_RP_TR_0001`Y`Y001",
        tt: "UI",
        ctlN: "UCV",
        // ttlAlg: "top",
        // useTim: 0,
        // visible: true
        // iconPh: "SD_RP_IR_0001`UI`UI01",
        // isBrdr: false,
        // isCls: false,
        // isFrm: false,
        // isHdn: false,
        // isScl: false,
        // isTtl: false,
        // lastParentId: "Ext.data.TreeModel-3",
        // lt: {
        //     c: "fit",
        //     desId: "EP_EO_UI_5002"
        // },
        // new_flag: true,
        // prmT: "C",
    })
};
export { SgiUCVEO };
export default SgiUCVEO;


// WEBPACK FOOTER //
// ./~/rt-sd-common/sgiCompEO/SgiUCVEO.js